import { ScanSourceConnectors } from './parcelSearch';

export enum TransientStorageType {
    customer = 'customer',
    customerList = 'customerList',
    dealer = 'dealer',
    locationShipmentTracking = 'locationShipmentTracking',
    parcelSearchRequest = 'parcelSearchRequest',
    parcelDetailsRequest = 'parcelDetailsRequest',
    userPermission = 'userPermission',
}

export type TransientStorageItem<T> = {
    type: TransientStorageType;
    dateCreated: Date;
    data: T;
};

export type LocationInfo = {
    accountId: string;
    parentAccountId: string;
    name: string;
    addressLine1: string;
    addressZip: string;
    addressCity: string;
    addressState: string;
    locationType: string;
    locationCode: string;
    fmtpCustomerId?: string;
};

export type ParcelSearchTransientStorageItems = {
    transactionId: string;
    results: Record<ScanSourceConnectors, string>;
};
